import PatBriefInhalt from '@/types/PatBriefInhalt';
import Briefart from '@/types/Briefart';

export default class PatBrief {
    /** PK: PatBrief | erforderlich **/
    public patbrief_id: number | null = null;
    /**  | erforderlich **/
    public patnr: number | null = null;
    /**  | erforderlich **/
    public datum: string | null = null;
    /** FK: PatBrief | erforderlich **/
    public briefart_id: number | null = null;
    /**  | max. 255 Zeichen **/
    public schlusstext: string | null = null;
    /**  | max. 20 Zeichen **/
    public arzt: string | null = null;
    /** Verweis auf Tab. Personen, durchführende Person (Arzt) **/
    public person_id_arzt: number | null = null;
    /**  | max. 1073741823 Zeichen **/
    public adresskopf: string | null = null;

    public briefart_art: string | null = null;
    public arzt_name: string | null = null;
    public briefinhalte: PatBriefInhalt[] = [];

    constructor(brief?: Partial<PatBrief | null>) {
        Object.assign(this, brief);

        this.briefinhalte = (new Array(Briefart.MAX_FIELDS))
            .fill(undefined)
            .map((_, index) => {
                const feldnummer = index + 1;
                return brief?.briefinhalte?.find((briefinhalt) => briefinhalt.feldnummer === feldnummer) ??
                    new PatBriefInhalt(feldnummer);
            });
    }
}
